import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { ContentLayoutComponent } from './layouts/content/content-layout.component';
import { FullLayoutComponent } from './layouts/full/full-layout.component';
import { UserLayoutComponent } from './layouts/user-layout/user-layout.component';

import { AuthService } from './shared/auth/auth.service';
import { AuthGuard } from './shared/auth/auth-guard.service';
import { AuthUserGuard } from './shared/auth/auth-user.guard.service';

import * as $ from 'jquery';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import * as firebase from 'firebase';
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { LoginSuperadminComponent } from './pages/login-superadmin/login-superadmin.component';
import { LoginAdminComponent } from './pages/login-admin/login-admin.component';
import { LoginUserComponent } from './pages/login-user/login-user.component';
import { HomeComponent } from './pages/home/home.component';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { RegisterComponent } from './pages/register/register.component';
import { ErrorPageComponent } from './pages/error/error-page.component';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { EventViewComponent } from './pages/event-view/event-view.component';
import { SigninComponent } from './pages/signin/signin.component';
// const config = {
//   apiKey: 'AIzaSyBA0dXYonoEjTrZHWefma9hLXUQoD82EJY',
//   authDomain: 'test-psg-events.firebaseapp.com',
//   databaseURL: 'https://test-psg-events.firebaseio.com',
//   projectId: 'test-psg-events',
//   storageBucket: 'test-psg-events.appspot.com',
//   messagingSenderId: '429494025498'
// };
// firebase.initializeApp(config);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    FullLayoutComponent,
    ContentLayoutComponent,
    LoginSuperadminComponent,
    LoginAdminComponent,
    LoginUserComponent,
    HomeComponent,
    RegisterComponent,
    ErrorPageComponent,
    UserLayoutComponent,
    EventViewComponent,
    SigninComponent
  ],
  imports: [
    ProgressSpinnerModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    ToastrModule.forRoot(),
    AngularFirestoreModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(environment.config),
    AngularFireAuthModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    NgbModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [AuthService, AuthGuard, AuthUserGuard],
  bootstrap: [AppComponent]
})
export class AppModule {}
